import { NoteKind } from '../services/note/note.model'

// Notes on records (emission, location, supplier, vehicle, reporting period). The backend validates
// the same values in lib/notes/note.constants.js; keep the two in step.

export const NOTE_BODY_MAX = 5000

// The character counter appears once a note gets close to the cap.
export const NOTE_BODY_COUNTER_FROM = 4500

export const NOTE_KIND_OPTIONS: { value: NoteKind; label: string }[] = [
  { value: 'general', label: 'General' },
  { value: 'estimate', label: 'Estimate' },
  { value: 'exclusion', label: 'Exclusion' },
]

// Whether a new note starts out included in the audit pack. A general note stays in the app unless
// the author says otherwise; an estimate or an exclusion explains a reported figure, so the auditor
// gets it by default. Notes are never printed in reports either way.
export const NOTE_KIND_DEFAULT_DISCLOSE: Record<NoteKind, boolean> = {
  general: false,
  estimate: true,
  exclusion: true,
}

export const getNoteKindLabel = (kind: NoteKind): string =>
  NOTE_KIND_OPTIONS.find((option) => option.value === kind)?.label ?? kind
